import { useMemo as i } from "react";
import { selectIsAuthenticated as A, selectIsCurrentUserGuest as a, selectAuthStatus as h, selectAuthRoles as f } from "../selectors.es.js";
import { useAuthStore as u } from "../store.es.js";
const l = (s, e, c) => s ? c ? (typeof s == "string" ? [s] : s).reduce(
  (t, o) => {
    const n = !!e && !!e[o];
    return t[0][o] = n, t[1] = t[1] && n, t;
  },
  [{}, !0]
) : [{}, !1] : [{}, !0], g = (s) => {
  const e = u(A), c = u(a), r = u(h), t = u(f), [o, n] = i(
    () => l(s, t, e),
    [s, e, t]
  );
  return {
    isAuthenticated: e,
    isGuest: c,
    status: r,
    isLoading: !r || r === "loading",
    hasAccess: n,
    access: o,
    roles: t
  };
};
export {
  l as checkAccess,
  g as useHasAccess
};
